import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import {
  GridData,
  CellComponent,
  CellContext,
  DateDisplayConfig,
} from '@grid/models';
import { Constants } from '@grid/utils/constants';

@Component({
  selector: 'app-date-display',
  template: `
    <div
      [attr.data-testId]="
        'display-' + context.column.header.name + '-' + context.row.index
      "
      class="d-flex align-items-center h-100"
      [ngClass]="{
        'justify-content-between': config?.justifyContentForDisplay
      }"
    >
      <span>{{
        context.data[context.column.columnDef]
          | date : config?.format ?? Constants.DefaultValues.dateDisplayFormat
      }}</span>
      <mat-icon
        svgIcon="calendar"
        class="ml-1 icon--primary"
        style="transform: translateY(-1px);"
      ></mat-icon>
    </div>
  `,
})
export class DateDisplayComponent
  implements CellComponent<GridData>, OnChanges
{
  @Input({ required: true }) context!: CellContext<GridData>;

  Constants = Constants;
  format: string;

  get config(): DateDisplayConfig {
    return this.context.config as DateDisplayConfig;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.context) {
      this.format = this.config.format;
    }
  }
}
